import {useCreateReservationContext} from '../ReservationContext'

import PoweredByJusto from './PoweredByJusto'
import SubmitButton from './SubmitButton'

export default function Submit() {
  const context = useCreateReservationContext()
  const message = context.storeOptions.preReservationMessage
  return (
    <div>
      {message && <div className="mb-4">{message}</div>}
      <SubmitButton />
      <PoweredByJusto />
    </div>
  )
}
